<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null" [nzWidth]="500"
  [nzClosable]="false">
  <ng-template #modalContent>
    <div nz-row>
      <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-left">
        <div class="title-text-model sub-header-font-size">{{'S0000.S0013' | translate}}</div>
      </div>
    </div>
    <div nz-row class="text-center">
      <div nz-col nz-col nzXs="24" nzLg="24" nzXl="24" class="text-center">
        <nz-upload [(nzFileList)]="fileList" [nzBeforeUpload]="beforeUpload">
          <input nz-col nzXs="19" nzLg="19" nzXl="18" class="input-radius body-font-size" nz-input readonly />
          <button class="upload-button search-button body-font-size" nz-button nzType="primary">
            <i class="upload-icon" nz-icon nzType="folder-open" nzTheme="fill"></i>
          </button>
        </nz-upload>
      </div>
    </div>
    <div nz-row style="margin-bottom:10px; margin-top:10px;">
      <div nz-col nzXs="24" nzLg="24" nzXl="24" class="text-center">
        <div class="worning-text body-font-size">* {{'S0000.S0019' | translate}}</div>
      </div>
    </div>
    <div nz-row class="line" style="border-bottom: 1px solid #DBDBDB; margin-bottom:10px;"></div>
    <div nz-row *ngFor="let item of fileList; let i = index">
      <div nz-col nzXs="2" nzLg="2" nzXl="2"></div>
      <div nz-col nzXs="20" nzLg="20" nzXl="20" class="hover">
        <div nz-row>
          <div nz-col nzXs="18" class="text-left">
            <div class="file-list-text body-font-size">{{item.name}}</div>
          </div>
          <div nz-col nzXs="6" class="text-right">
            <div class="file-size-text body-font-size">{{ convertByteToMB(item.size) | number:'0.2-2'}} MB
              <i nz-icon style="margin-left: 6px;" (click)="deleteUploadFile(i)" nz-tooltip
                nzTooltipTitle="{{'J0000.J0030' | translate}}" nzTooltipPlacement="right" nzType="delete" nzTheme="fill"
                class="icon-delete"></i>
            </div>
          </div>
        </div>
      </div>
      <div nz-col nzXs="2" nzLg="2" nzXl="2"></div>
    </div>
    <nz-alert class="body-font-size" [hidden]="correctFileType" nzType="error" nzCloseText="X"
      nzDescription="สามารถเพิ่มไฟล์ได้ แค่ .pdf เท่านั้น กรุณาเลือกไฟล์ใหม่" nzShowIcon>
    </nz-alert>
    <nz-alert class="body-font-size" [hidden]="!overSize" nzType="error" nzCloseText="X"
    nzDescription="{{ 'rejectAddFile25' | translate}}"
    nzShowIcon>
    </nz-alert>
    <div nz-row class="mt-5">
      <div nz-col nzSpan="24" class="pr-1">
        <div class="btn-wrapper" style="text-align: center;">
          <div (click)="uploadFile()" class="btn-styles text-center btn-blue body-font-size">
            <div class="txt">
              <button  class="body-font-size" type="button">{{'ok' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</nz-modal>